(function () {
  "use strict";

  function initStickyAtc() {
    const sticky = document.getElementById("m-sticky-atc");
    const form = document.querySelector(".m-picker-new-form");
    if (!sticky || !form) return;

    const select = sticky.querySelector("[data-sticky-variant-select]");
    const atcBtn = sticky.querySelector("[data-sticky-atc-trigger]");
    const variantInput = form.querySelector("[data-variant-id-input]");
    const sellingPlanInput = form.querySelector("[data-selling-plan-input]");
    const mainAtcBtn = form.querySelector(".kaching-atc-trigger");
    const subCheckbox = form.querySelector(".m-subscription-checkbox, [data-subscription-checkbox]");

    if (!select || !atcBtn || !variantInput || !mainAtcBtn) return;
    // ─── Scroll visibility: use PICKER FORM (has real size) — show when its bottom scrolls above viewport ───
    const trackEl = form;
    function updateStickyVisibility() {
      const rect = trackEl.getBoundingClientRect();
      const shouldShow = rect.bottom <= 0;
      if (shouldShow) {
        sticky.classList.add("is-visible");
        sticky.style.display = "";
        sticky.setAttribute("aria-hidden", "false");
      } else {
        sticky.classList.remove("is-visible");
        sticky.style.display = "none";
        sticky.setAttribute("aria-hidden", "true");
      }
    }

    const observer = new IntersectionObserver(
      () => updateStickyVisibility(),
      { threshold: [0, 1], rootMargin: "0px" }
    );
    observer.observe(trackEl);

    window.addEventListener("scroll", updateStickyVisibility, { passive: true });
    updateStickyVisibility();

    // ─── Sync dropdown with form; update form when dropdown changes ───
    function syncFormFromSticky() {
      const variantId = select.value;
      variantInput.value = variantId;

      // Update selling plan from subscription checkbox
      if (sellingPlanInput && subCheckbox && subCheckbox.checked) {
        const pickerDataEl = form.querySelector("[data-picker-variants]");
        if (pickerDataEl) {
          try {
            const data = JSON.parse(pickerDataEl.textContent);
            const variant = data.variants?.find(
              (v) => String(v.id) === String(variantId)
            );
            sellingPlanInput.value = variant?.selling_plan_id || "";
          } catch (_) {
            sellingPlanInput.value = "";
          }
        }
      } else if (sellingPlanInput) {
        sellingPlanInput.value = "";
      }

      // Sync picker bar selection
      const bar = form.querySelector(
        `.m-picker-bar[data-variant-id="${variantId}"]`
      );
      if (bar) {
        form.querySelectorAll(".m-picker-bar").forEach((b) => {
          b.classList.remove("m-picker-bar--selected");
        });
        bar.classList.add("m-picker-bar--selected");
        const radio = form.querySelector(
          `input[name="picker-selection"][value="${variantId}"]`
        );
        if (radio) radio.checked = true;
      }
    }

    // ─── Sync sticky dropdown when picker bar is clicked ───
    form.querySelectorAll(".m-picker-bar").forEach((bar) => {
      bar.addEventListener("click", () => {
        const vid = bar.dataset.variantId;
        if (vid && select.value !== vid) {
          select.value = vid;
        }
      });
    });

    // ─── Initial sync: reflect the picker's currently selected bar ───
    const selectedBar = form.querySelector(".m-picker-bar--selected");
    if (selectedBar && selectedBar.dataset.variantId) {
      const opt = select.querySelector(
        `option[value="${selectedBar.dataset.variantId}"]`
      );
      if (opt) select.value = selectedBar.dataset.variantId;
    }

    select.addEventListener("change", syncFormFromSticky);

    // ─── Sticky ATC click: update form then trigger main ATC ───
    atcBtn.addEventListener("click", (e) => {
      e.preventDefault();
      syncFormFromSticky();
      mainAtcBtn.click();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStickyAtc);
  } else {
    initStickyAtc();
  }
  document.addEventListener("shopify:section:load", initStickyAtc);
})();
